import type { Customer, OrderOrder, Settings } from '../../../types/codexOrder';
import {
  ChevronLeftIcon,
  LocationIcon,
  ShopIcon,
  MotorCycleIcon,
} from '../../../assets/Icons';
import { getRedirectUrlForMaps, openUrl } from '../../../helpers/utils';
import { ApiConstants } from '../../../constants/ApiConstants';

function OrderFulfillment({
  order,
  settings,
  customer,
  awaitingCheckout,
  updateTypeModalOpen,
  isDeliveryWoAddress,
}: {
  awaitingCheckout: boolean;
  order: OrderOrder | undefined;
  customer: Customer | undefined;
  settings: Settings | undefined;
  updateTypeModalOpen: (v: boolean) => void;
  isDeliveryWoAddress: boolean;
}) {
  const store = order?.store;
  const brand = order?.details?.brand;
  const customerAddress = customer?.address ?? {};
  const isDelivery = order?.details?.order_type === ApiConstants.TYPE_DELIVERY;

  function getActionView() {
    if (
      settings &&
      awaitingCheckout &&
      settings?.fulfillment_modes?.length > 1
    ) {
      return (
        <p
          onClick={() => {
            updateTypeModalOpen(true);
          }}
          className="text-brand-icon text-sm cursor-pointer mt-3 flex items-center max-w-max">
          <span>Change</span>
          <ChevronLeftIcon className="w-4 h-4 rotate-180 mt-0.5" />
        </p>
      );
    }

    if (!isDelivery && store?.latitude && store?.longitude) {
      return (
        <p
          onClick={() => {
            openUrl(
              getRedirectUrlForMaps(
                `${brand?.name ? `${brand?.name} - ` : ''}${store?.name || ''}`,
                store?.latitude?.toString(),
                store?.longitude?.toString(),
              ),
            );
          }}
          className="text-brand-icon text-sm cursor-pointer mt-3 flex items-center max-w-max">
          <span>Get directions</span>
          <ChevronLeftIcon className="w-4 h-4 rotate-180 mt-0.5" />
        </p>
      );
    }
  }

  return (
    <div className="p-4 rounded-lg bg-white mb-4">
      <div className="flex items-center gap-x-2 mb-3">
        {isDelivery ? (
          <MotorCycleIcon className="text-brand-icon" />
        ) : (
          <ShopIcon className="text-brand-icon" />
        )}
        <p className="font-bold">
          {isDelivery ? 'Delivering to' : 'Pickup from'}
          {isDelivery && customerAddress.tag
            ? ` ${customerAddress.tag?.split('__')[0]}`
            : ''}
        </p>
      </div>
      {!isDeliveryWoAddress && (
        <div className="flex items-center gap-x-2">
          <LocationIcon className="text-up-black-80" />
          <p className="text-sm">
            {isDelivery
              ? [
                  customerAddress.line_1,
                  customerAddress.line_2,
                  customerAddress.sub_locality,
                  customerAddress.landmark,
                  customerAddress.city,
                  customerAddress.pin,
                ]
                  .filter(Boolean)
                  .join(', ')
              : (store?.address ?? '-')}
          </p>
        </div>
      )}
      {getActionView()}
    </div>
  );
}

export default OrderFulfillment;
